export default {
  reloadEmail: state => state.reloadEmail,
};
